import React from 'react';
import { iconValid } from '../../helpers';
import { Spacer } from '../Spacer/Spacer';
import { StyledPagination, PageNum, Marker, EndButton } from './styles';
import _ from 'lodash';
const Pagination = props => {
  const {
    theme,
    selectedTheme,
    totalPages,
    currentPage,
    onPageChange,
    prevIcon,
    pageIcon,
    nextIcon,
    noMarker,
    markerSpacing,
    markerWidth,
    markerHeight,
    numberSize,
    boldActive,
    truncateLimit,
    endButtons,
    activeColor,
    visible,
    inactiveColor
  } = props;
  const page = currentPage || 1;
  const total = totalPages || 1;
  const onFirst = page === 1;
  const onLast = page === total;
  const prev = !onFirst && page - 1;
  const next = !onLast && page + 1;
  const changePage = num => {
    const isDifferent = page !== num;
    if (num && onPageChange && isDifferent) {
      onPageChange(num);
    }
  };
  const icon = (icon, fallback) => iconValid(icon) || `fa-solid fa-${fallback}`;
  const pageElement = (i, workingPage) => {
    return /*#__PURE__*/React.createElement(PageNum, {
      $theme: theme,
      $selectedTheme: selectedTheme,
      key: i,
      $active: i === page,
      $numberSize: numberSize,
      $boldActive: boldActive,
      $activeColor: activeColor,
      $inactiveColor: inactiveColor,
      $isSpread: _.isString(i),
      onClick: () => _.isNumber(i) && changePage(i)
    }, workingPage, !noMarker && /*#__PURE__*/React.createElement(Marker, {
      $theme: theme,
      $selectedTheme: selectedTheme,
      $active: i === page,
      $markerSpacing: markerSpacing,
      $markerWidth: markerWidth,
      $markerHeight: markerHeight,
      $activeColor: activeColor,
      $inactiveColor: inactiveColor
    }));
  };
  const pageNum = () => {
    const first = pageElement(1, pageIcon ? /*#__PURE__*/React.createElement("i", {
      className: icon(pageIcon, 'circle')
    }) : 1);
    const last = pageElement(total, pageIcon ? /*#__PURE__*/React.createElement("i", {
      className: icon(pageIcon, 'circle')
    }) : total);
    const renderContent = [];
    for (let i = 1; i <= total; i++) {
      let workingPage = i;
      if (pageIcon) workingPage = /*#__PURE__*/React.createElement("i", {
        className: icon(pageIcon, 'circle')
      });
      renderContent.push(pageElement(i, workingPage));
    }
    if (truncateLimit < total - 1) {
      if (page <= truncateLimit) {
        renderContent.splice(truncateLimit, total - truncateLimit);
        return [...renderContent, pageElement('endSpread', '...'), last];
      }
      if (page > truncateLimit && page <= total - truncateLimit) {
        renderContent.splice(0, page - truncateLimit + 2);
        renderContent.splice(truncateLimit, total - page);
        return [first, pageElement('startSpread', '...'), ...renderContent, pageElement('endSpread', '...'), last];
      }
      if (page > total - truncateLimit) {
        renderContent.splice(0, total - truncateLimit);
        return [first, pageElement('startSpread', '...'), ...renderContent];
      }
    }
    return renderContent;
  };
  return /*#__PURE__*/React.createElement(StyledPagination, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $inactiveColor: inactiveColor,
    $visible: visible !== undefined ? visible : totalPages > 1
  }, (endButtons || truncateLimit) && /*#__PURE__*/React.createElement(EndButton, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $activeColor: activeColor,
    $inactiveColor: inactiveColor
  }, /*#__PURE__*/React.createElement("i", {
    role: "none",
    className: `prev ${icon(prevIcon, 'chevron-left')}`,
    onKeyUp: e => e.key === 'Enter' && changePage(prev),
    onClick: () => changePage(prev)
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: 0.5,
    across: true
  })), pageNum(), (endButtons || truncateLimit) && /*#__PURE__*/React.createElement(EndButton, {
    $theme: theme,
    $selectedTheme: selectedTheme,
    $activeColor: activeColor,
    $inactiveColor: inactiveColor
  }, /*#__PURE__*/React.createElement(Spacer, {
    size: 0.5,
    across: true
  }), /*#__PURE__*/React.createElement("i", {
    role: "none",
    className: `next ${icon(nextIcon, 'chevron-right')}`,
    onKeyUp: e => e.key === 'Enter' && changePage(next),
    onClick: () => changePage(next)
  })));
};
export { Pagination };